import { render, staticRenderFns } from "./flexBtn.vue?vue&type=template&id=48ef7a5a&scoped=true"
import script from "./flexBtn.vue?vue&type=script&lang=js"
export * from "./flexBtn.vue?vue&type=script&lang=js"
import style0 from "./flexBtn.vue?vue&type=style&index=0&id=48ef7a5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ef7a5a",
  null
  
)

export default component.exports